import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type PropsType = {
	className?: string;
	children: any;
};

export const ActionsContainer = ({ className, children }: PropsType) => {
	return (
		<div className={clsx(styles.actionsContainer, className)}>
			{children}
		</div>
	);
};
